import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Route gate.
 *
 * `usherOnly` guards the scanner: subscribers may read the dashboard and
 * check-in history but cannot scan or check anyone in, so they are sent to
 * the dashboard instead. Note this is a convenience, not a security control -
 * the API enforces the same split server-side.
 */
function PrivateRoute({ children, usherOnly = false }) {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  if (!isLoggedIn) return <Navigate to="/login" />;

  const role = localStorage.getItem('role') || 'usher';
  if (usherOnly && role !== 'usher') return <Navigate to="/dashboard" replace />;

  return children;
}

export default PrivateRoute;
